import { render, staticRenderFns } from "./add-note.vue?vue&type=template&id=581e4958&"
import script from "./add-note.vue?vue&type=script&lang=js&"
export * from "./add-note.vue?vue&type=script&lang=js&"
import style0 from "./add-note.vue?vue&type=style&index=0&id=581e4958&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports